// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"q2-z","displaySixCardTiles":"r2-z"};